var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ctk-sort-dropdown',{staticClass:"offers-sort-dropdown",attrs:{"id":"sort-offers","initial-value":'pickup_date',"value":[
    {
      value: _vm.getOffersSortType
    }
  ],"text":_vm.valueText,"items":_vm.items,"small":false},on:{"input":_vm.sortOffers}})}
var staticRenderFns = []

export { render, staticRenderFns }